// Client mirror of functions/formulaLibrary.js `deriveCagrFiscalYears`.
//
// CRA's ModuleScopePlugin forbids the app bundle from importing anything under
// functions/, so this derivation is duplicated here DELIBERATELY. It must stay
// byte-for-byte equivalent to the server's: src/utils/cagrAnchor.test.js is a
// drift-guard that imports BOTH copies and asserts identical output for the same
// inputs (the same pattern that guards the CAGR label strings). If you change
// one, change the other and keep that test green.
//
// year(i) = A - (N - 1 - i) over FILLED slots (oldest-first), so the newest
// filled slot is the anchor A and each earlier slot is one year older.
export function deriveCagrFiscalYears({ year_question_ids: yearQuestionIds, anchor }) {
  const filled = (yearQuestionIds || []).filter(Boolean);
  if (!filled.length) return {};

  const a = parseInt(anchor, 10);
  if (!Number.isInteger(a)) {
    throw new Error(
      'USD CAGR needs the most recent completed financial year — no ' +
      'completed financial year provided on this submission.',
    );
  }

  const n = filled.length;
  const byId = {};
  filled.forEach((qid, i) => {
    byId[qid] = a - (n - 1 - i);
  });
  return byId;
}

// Client mirror of functions/formulaLibrary.js `deriveFutureCagrFiscalYears`.
// Same drift-guard applies (src/utils/cagrAnchor.test.js asserts identical
// output against the server copy). The FUTURE series is POSITIONAL and runs
// forward: year(i) = A + 1 + i, so slot 0 is the current financial year A+1.
export function deriveFutureCagrFiscalYears({ slot_count: slotCount, anchor }) {
  const n = parseInt(slotCount, 10);
  if (!Number.isInteger(n) || n < 1) return [];

  const a = parseInt(anchor, 10);
  if (!Number.isInteger(a)) {
    throw new Error(
      'Future USD CAGR needs the most recent completed financial year — no ' +
      'completed financial year provided on this submission.',
    );
  }
  return Array.from({ length: n }, (_, i) => a + 1 + i);
}
